module.exports = __webpack_public_path__ + "static/media/BgDotWave.0096926b.png";